import React from "react";

export const LeftArrowIcon = () => (
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 2.00756L8.49618 0.50374L0 8.99992L8.49618 17.4961L10 15.9923L3.00765 8.99992L10 2.00756Z" fill="white"/>
    <path d="M20 2.00756L18.4962 0.50374L10 8.99992L18.4962 17.4961L20 15.9923L13.0076 8.99992L20 2.00756Z" fill="white"/>
  </svg>
);